import { DatePipe } from '@angular/common';
import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'dateFormat'
})
export class DateFormatPipe implements PipeTransform {
  transform(value: any, args?: any): any {
    var datePipe = new DatePipe("de");
    value = datePipe.transform(value, 'dd.MM.yyyy HH:mm:ss');
    return value;
  }
}